/** Review route builders — keep out of Layout.tsx to avoid circular imports. */

export function podcastContentAnalysisPath(podcastId: string): string {
  return `/review/${podcastId}`;
}

export function podcastTaxonomyTopicsPath(podcastId: string): string {
  return `/review/${podcastId}/topics`;
}

export function contentTaxonomyTopicsPath(contentId: string): string {
  return `/review/content/${contentId}/topics`;
}
